// @flow
// @jsx h
import { h, Component } from "preact";
import { Text } from "preact-i18n";

import styles from "./BookingParticipantClientForms.scss";
import ParticipantClientForm from "./participant-client-form/ParticipantClientForm.js";
import { getParticipantClientData } from "elc-open-api";

export default class BookingParticipantClientForms extends Component {
    constructor(props) {
    super(props);
    this.formsRefs = [];
    this.openStates = [];
  }

  state = {
    currentOpenedParticipants: 1,
    savedParticipants: {},
    formParticipantsValid: {},
    clientData:[],
  };

  
  validate() {
    // appelle la validation de chaque ParticipantClientForm
    const results = this.formsRefs.map((ref, index) => {
      return  ref && ref.validate()
    });
    const allValid = results.every(valid => valid === true);
    return allValid;
  }

  componentDidMount() {
    getParticipantClientData(this.props.booking.id)
      .then(participantClientData => {
        // crée objet confirmation email si mail présent lors de la recuperation des data
        const emailEntry = participantClientData._embedded.clientData.filter(
          data => data._embedded.clientFormInputTypeSaved.inputType === "EMAIL"
        );

        let emailConfirmEntry = [];
        if (emailEntry.length > 0) {
          emailEntry.map(data => {
              emailConfirmEntry.push({
                    ...data, // copie toutes les propriétés existantes
                    id:-1,
                    value: data.value,
                    _embedded : {
                        clientFormInputTypeSaved: {
                          ...data._embedded.clientFormInputTypeSaved,
                          id: -9999,
                          type: data._embedded.clientFormInputTypeSaved.type,
                          code: "emailconfirm",
                          inputType: "EMAILCONFIRM"
                        }
                    }
                })
          })


        }

      const newClientData = emailConfirmEntry.length > 0
        ? [...participantClientData._embedded.clientData, ...emailConfirmEntry]
        : participantClientData._embedded.clientData;

        // console.log("participantClientData", participantClientData)
        // console.log("participantClientData - emailConfirmEntry", emailConfirmEntry)
        
        this.setState({
          clientData: newClientData
        });
        //console.log("componentDidMount - participantClientData", participantClientData._embedded.clientData)
        //return participantClientData;
      })
      .catch(error => {
        console.error("Error getParticipantClientData", error);
      });
  }


  onParticipantSaved = (index, newClientData) => {
    //console.log("newClientData", newClientData)

    this.setState(prevState => {
      //console.log("prevState.clientData", prevState.clientData)
      prevState.savedParticipants[index] = true;

      prevState.clientData = prevState.clientData.filter(field => {
        return (
          field.participantIndex !==
          newClientData[0].participantIndex
        );
      });
      prevState.clientData = [
        ...prevState.clientData,
        ...newClientData
      ];
      return prevState;
    });

  };

  isFormValid = (val, index, forceUpdate) => {

    
    // console.log("isFormValid - BookingParticipantClientForms - val", val)
    // console.log("isFormValid - BookingParticipantClientForms - index", index)
    // console.log("isFormValid - BookingParticipantClientForms - forceUpdate", forceUpdate)

          this.setState(prevState => {
            if (val === true || (prevState.formParticipantsValid[index] === true && val === false) || forceUpdate == true) {
              return {
                formParticipantsValid: {
                  ...prevState.formParticipantsValid,
                  [index]: val
                }
              };
            }
            //  state tel quel
            return null;
          },
        () => {
            if(val === true && forceUpdate == true){
              let idx = index;
              this.openStates[idx-1] = false
              // on incrémente tant que le participant est valide
              while (this.state.formParticipantsValid[idx + 1] === true) {
                this.openStates[idx] = false
                idx++;
              }
              this.handleNext(idx)
            }
            
        });

  }

  handleNext = (currentIndex) => {
    const nextIndex = currentIndex + 1;
    const { booking } = this.props

    this.openStates[currentIndex-1] = false
    //passe au suivant
    if (currentIndex < booking.quantity) {
      this.setState({ currentOpenedParticipants: nextIndex });
      //scroll premiére erreur dans la page
      
      setTimeout(() => {  
        const firstInvalid = document.querySelector(`[data-index="${booking.id}-${nextIndex}"]`);
        if (firstInvalid) {
          firstInvalid.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 0);

    }   // Si on est sur le dernier, on le ferme
    else if (currentIndex === booking.quantity) {
      this.setState({ currentOpenedParticipants: null });
    }

  };


  computeOpen = (participantIndex) => {
      const { formParticipantsValid, currentOpenedParticipants } = this.state;
      // État précédent (null si jamais défini)
      const prevOpen = this.openStates[participantIndex] ?? null;
      let open = prevOpen; // on part de l’état précédent

      // Si jamais il n’a jamais été défini et que le formulaire est invalide → on ouvre
      if (prevOpen === null && formParticipantsValid[participantIndex + 1] === false) {
        open = true;
      }
      // Si le participant actuel est en cours d’édition → on ouvre
      else if (participantIndex + 1 === currentOpenedParticipants && prevOpen === null) {
        open = true;
      }
      // Si le participant redevient invalide → on rouvre
      else if (formParticipantsValid[participantIndex + 1] === false) {
        open = true;
      }
      // 
      else if (prevOpen === false && formParticipantsValid[participantIndex + 1] === true && participantIndex + 1 === currentOpenedParticipants) {
        open = true;
      }

      // On met à jour seulement si on ouvre
      if (open) {
        this.openStates[participantIndex] = true;
      }

      return open;
      }

  pageDidMountOrUpdate = () => {
    console.log("this.props", this.props)
    if(this.props.pageDidMountOrUpdate){
      this.props.pageDidMountOrUpdate()
    }       
  }


  render({ booking, participantClientForm, oneProductOneParticipant, currentTheme, localeString, pageDidMountOrUpdate}, { clientData, formParticipantsValid }) {
    this.formsRefs = [];

    let forms = [];
    for (
      let participantIndex = 0;
      participantIndex < booking.quantity;
      participantIndex++
    ) {
     
      forms.push(
        <div
          class={`${styles.participantContainer} `}
        >
          <details class={`${formParticipantsValid[participantIndex + 1] == true ? styles.isValidForm : ""} ${formParticipantsValid[participantIndex + 1] == false ? styles.invalidValidForm : ""}`}
                    open={this.computeOpen(participantIndex)}
                    data-invalid={formParticipantsValid[participantIndex + 1] === false }
                    data-index={`${booking.id}-${participantIndex + 1}`}
                    >

            <summary class={`${styles.participantNb}`}
            onClick={() => { this.pageDidMountOrUpdate(); }}
            >
              <span class={`${styles.status} `}>
              <Text
                id={
                  booking.quantity == 1
                    ? 'participantClientForm.participantSingle'
                    : 'participantClientForm.participantNb'
                }
                fields={{
                  number: participantIndex + 1
                }}
              >
                Participant n°{participantIndex + 1}
              </Text>
              </span>
            </summary>
              <div class={`${styles.content} `}>
                  <div class={styles.participantFormContainer}>
                    <ParticipantClientForm                    
                      key={participantIndex}
                      participantIndex={participantIndex}
                      participantClientForm={participantClientForm}
                      clientData={
                        clientData && Array.isArray(clientData) && clientData.length > 0
                        ? clientData
                            .filter(data => data.participantIndex === participantIndex + 1)
                            .map(data => ({
                              participantIndex: data.participantIndex,
                              value: data.value,
                              clientFormInputType: {
                                id: data._embedded.clientFormInputTypeSaved.id,
                                type: data._embedded.clientFormInputTypeSaved.type,
                                code: data._embedded.clientFormInputTypeSaved.code
                              }
                            }))
                        : []
                      }
                      bookingId={booking.id}
                      locale={localeString}
                      onParticipantSaved={this.onParticipantSaved}
                      ref={ref => (this.formsRefs[participantIndex] = ref)}
                      isFormValid={this.isFormValid}
                      oneProductOneParticipant={oneProductOneParticipant}
                      currentTheme={currentTheme}
                      pageDidMountOrUpdate={pageDidMountOrUpdate}
                    />
                  </div>
              </div>
          </details>


        </div>
      );
    }

    return (
      <div>    
        {forms}
      </div>
    );
  }
}
